// 버튼 관련 스타일 컴포넌트들
import styled from '@emotion/styled';
// 채팅에 붙여넣기 버튼
export const PasteToChatButton = styled.button`
  background: none;
  border: none;
  color: var(--theme-text-secondary);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(--theme-spacing-xs);
  padding: var(--theme-spacing-xs) var(--theme-spacing-sm);
  border-radius: var(--theme-radius-sm);
  transition: background-color var(--theme-transition-fast), color var(--theme-transition-fast);

  &:hover {
    background-color: var(--theme-paper-hover);
    color: var(--theme-text);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
// 선택된 텍스트 전송 버튼
export const SelectionSendButton = styled.button`
  position: absolute;
  z-index: 10;
  background: var(--theme-primary);
  color: #fff;
  border: none;
  border-radius: var(--theme-radius-sm);
  padding: var(--theme-spacing-xs) var(--theme-spacing-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(--theme-spacing-xs);
  font-size: var(--theme-typography-font-size-xs);
  box-shadow: var(--theme-shadows-sm, none);
  transition: background-color var(--theme-transition-fast);

  &:hover {
    background-color: var(--theme-primary-dark);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
// 일반적인 붙여넣기 버튼
export const PasteButton = styled.button`
  position: absolute;
  top: var(--theme-spacing-xs);
  right: var(--theme-spacing-xs);
  padding: var(--theme-spacing-xs);
  background-color: var(--vscode-button-background, var(--theme-primary));
  color: var(--vscode-button-foreground, var(--theme-text-white));
  border: none;
  border-radius: var(--theme-radius-sm);
  cursor: pointer;
  z-index: 10;
  font-size: var(--theme-typography-font-size-xs);
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-xs);
  transition: all var(--theme-transition-fast) ease-in-out;

  &:hover {
    background-color: var(--vscode-button-hoverBackground, var(--theme-primary-dark));
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
// 일반적인 선택 버튼
export const SelectionButton = styled.button`
  position: absolute;
  background-color: var(--vscode-button-background, var(--theme-primary));
  color: var(--vscode-button-foreground, var(--theme-text-white));
  border: none;
  border-radius: var(--theme-radius-sm);
  padding: var(--theme-spacing-xs);
  cursor: pointer;
  z-index: 1000;
  font-size: var(--theme-typography-font-size-xs);
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-xxs);
  transition: all var(--theme-transition-fast) ease-in-out;
  box-shadow: var(--theme-shadow-md);

  &:hover {
    background-color: var(--vscode-button-hoverBackground, var(--theme-primary-dark));
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;
